import { Gift } from "lucide-react";

export default function GiftNoteBanner() {
  return (
    <section className="pb-16 md:pb-20 bg-white" data-testid="gift-note-banner-section">
      <div className="frida-container">
        <div className="flex items-center gap-5 md:gap-6 bg-[#FBF7EC] border border-[#D4A15C]/20 rounded-3xl p-6 md:p-8">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-[#D4A15C] flex items-center justify-center shrink-0">
            <Gift className="w-6 h-6 md:w-7 md:h-7 text-white" />
          </div>
          <div>
            <h3 className="font-serif text-lg md:text-xl text-[#222222] mb-1">
              Özel Not Kartı
            </h3>
            <p className="text-sm md:text-base text-[#555555] leading-relaxed">
              Siparişinize eklediğiniz özel notla duygularınızı tamamlayın — sepette dilediğiniz notu eklemeyi unutmayın.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
